import React from 'react';
import { withStyles } from '@material-ui/styles';
import { TextField, Typography, Grid, FormControl, FormLabel } from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';

const styles = theme => ({
    root: {
        flexGrow: 1
    }
});

class MerchantInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            list: [],
            type: 'all',
            searchValue: ''
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.type != this.props.type || prevState.searchValue != this.state.searchValue) {
            if (this.state.searchValue == '') {
                this.setState({
                    list: []
                });
            } else {
                this.getData();
            }
        }
    };

    componentDidMount = () => {
        //this.getData();
    };

    getData = () => {
        const { searchValue } = this.state;
        const args = `dataToRetrieve=merchants&search=${searchValue}`;

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/merchant/get-data-for-report-issue?${args}`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data
                });
            })
            .catch(error => {
                console.error(error);
                alert('Echec de la récupération des données');
            });
    };

    handleList = (event, value) => {
        this.props.setMerchant(value);
    };

    handleType = ({ target: { name } }) => {
        this.props.setType(name);
    };

    handleInputList = value => {
        this.setState(prevState => ({
            searchValue: value
            //list: value == "" ? [] : prevState.list
        }));
    };

    renderOptionsForm = option => {
        return option.raisonSociale !== undefined
            ? `${option.raisonSociale}${option.numero ? ' (N° ' + option.numero + ')' : ''} - ${
                  option.otherIntel
              }`
            : '';
    };

    render() {
        const { list, searchValue } = this.state;

        return (
            <Grid container direction="column" spacing={1} alignItems="stretch">
                <Grid item>
                    <FormControl required component="fieldset">
                        <FormLabel color="primary">Sélectionnez un commerçant</FormLabel>
                        {/*
                        <FormGroup row>
                            <FormControlLabel
                                control={<Checkbox onChange={this.handleType} checked={Boolean(type == "ta")} name="ta" />}
                                label="Titulaires abonnés"
                            />
                            <FormControlLabel
                                control={<Checkbox onChange={this.handleType} checked={Boolean(type == "tna")} name="tna" />}
                                label="Titulaires non abonnés"
                            />
                            <FormControlLabel
                                control={<Checkbox onChange={this.handleType} checked={Boolean(type == "p")} name="p" />}
                                label="Passagers"
                            />
                        </FormGroup>*/}
                    </FormControl>
                </Grid>
                <Grid item>
                    <Autocomplete
                        options={list}
                        name="list"
                        autoHighlight
                        multiple
                        onChange={this.handleList}
                        onInputChange={(event, value) => {
                            this.handleInputList(value);
                        }}
                        noOptionsText={searchValue == '' ? '' : "Aucun commerçant n'a été trouvé"}
                        getOptionLabel={option => this.renderOptionsForm(option)}
                        getOptionSelected={(option, value) => option.id == value.id}
                        renderOption={(option, value) => (
                            <Grid container direction="row" justify="space-between">
                                <Grid item>
                                    <Grid container direction="column" alignItems="stretch">
                                        <Grid item>
                                            {option.raisonSociale}
                                            {option.numero ? ' (N° ' + option.numero + ')' : ''}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body2">
                                                {option.otherIntel}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid
                                        container
                                        direction="column"
                                        justify="space-between"
                                        alignItems="flex-end">
                                        <Grid item>
                                            <Typography variant="overline">
                                                {option.status}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body2">
                                                {option.marketLabel}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        renderInput={params => (
                            <TextField
                                fullWidth
                                {...params}
                                helperText={
                                    'Saisir une raison sociale, une enseigne, un nom ou un prénom'
                                }
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(MerchantInput);
